import { DatePipe, UpperCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { IsFutureDatePipe } from '@zero/shared/ui-pipes';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { filter } from 'rxjs';
import { TeilrechtBase } from '../teilrecht.base';
import { TeilrechtBackLinkComponent } from './../back-link/teilrecht-back-link.component';

@Component({
  imports: [TranslocoPipe, RouterLink, TeilrechtBackLinkComponent, IsFutureDatePipe, DatePipe, ButtonComponent, UpperCasePipe],
  templateUrl: './teilrecht-home.component.html',
})
export class TeilrechtHomeComponent extends TeilrechtBase implements OnInit {
  public override ngOnInit(): void {
    super.ngOnInit();

    this.service.bezugsrechtData$
      .pipe(
        filter((data) => !!data?.directivePreview),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.router.navigateByUrl(`${this.rootUrl}/${this.TEILRECHT_ROUTES.SUMMARY}`));
  }

  public back = (): void => {
    this.router.navigateByUrl(this.commonRoutes.postlogin.member_home);
  };

  public loadPreview(direction: 'buy' | 'sell'): void {
    this.msgService.clearAllMessages();

    if (!this.model?.announcement) {
      this.msgService.addErrorMessage(this.translateService.translate('bezugsrecht-service.error'));
      return;
    }

    const { announcement } = this.model;
    const { ereignisnummer, avisTyp } = announcement;
    this.service.loadDirectivePreview(ereignisnummer, avisTyp, direction == 'buy' ? 1 : 0);
  }
}
